import moment from 'moment-timezone';

import { dateFormatOptions } from 'constants/global.const';

export const openPDFHandler = (filePath: string, event: React.MouseEvent<HTMLElement> | null = null) => {
  if (event) event.preventDefault();
  const alink = document.createElement('a');
  alink.href = filePath;
  alink.target = '_blank';
  alink.rel = 'noopener noreferrer';
  alink.click();
};

export const loadExternalScript = (url: string) => {
  const script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};

export const getUserAgentDetails = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isLandscape = window.matchMedia('(orientation: landscape)').matches;
  return { isMobile, isLandscape };
};

export const getCookiesAsJSON = (): Record<string, string> => {
  const cookies = document.cookie.split(';').map(cookie => cookie.trim());
  const cookieObj: Record<string, string> = {};
  cookies.forEach(cookie => {
    const [key, value] = cookie.split('=');
    cookieObj[key] = value;
  });

  return cookieObj;
};

export const getAuthData = () => {
  const {
    REACT_APP_BASE_URL_LOCAL,
    REACT_APP_BASE_API_URL,
    REACT_APP_LOGIN_URL,
    REACT_APP_CONSUMER_ID,
    REACT_APP_COMSUMER_SECRET,
  } = process.env;

  const REACT_APP_CALL_BACK_URL =
    window.location.hostname === 'localhost' ? REACT_APP_BASE_URL_LOCAL : REACT_APP_BASE_API_URL;

  return {
    loginUrl: REACT_APP_LOGIN_URL || '',
    clientId: REACT_APP_CONSUMER_ID || '',
    clientSecret: REACT_APP_COMSUMER_SECRET || '',
    redirectUri: REACT_APP_CALL_BACK_URL + '/home' || '',
  };
};

export const postDataToParent = (value: any) => {
  const chatbotData = { message: 'ChatbotData', value };
  window.parent.postMessage(chatbotData, '*');
};

export const formatDate = (timestamp: string) => {
  if (!timestamp.toLocaleLowerCase().endsWith('z')) {
    timestamp = `${timestamp}Z`;
  }

  const dateToFormat = new Date(timestamp);
  return dateToFormat.toLocaleDateString(undefined, dateFormatOptions);
};

let timeoutId: NodeJS.Timeout | null = null;
let lastArgs: Parameters<any> | null = null;
export const debounce = <F extends (...args: any[]) => void>(func: F, delay: number) => {
  const debounced = function (this: ThisParameterType<F>, ...args: Parameters<F>) {
    lastArgs = args;
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      if (lastArgs !== null) {
        func.apply(this, lastArgs);
        lastArgs = null;
        timeoutId = null;
      }
    }, delay);
  };
  return debounced;
};

export const formatDateLocalTZ = (date: string) => {
  let formattedDate = '-';
  if (date) {
    const format = `DD MMM YYYY, HH:mm:ss`;
    const LOCAL_TIME_ZONE = moment.tz.guess();
    const LOCAL_TZ_CODE = moment.tz(LOCAL_TIME_ZONE).format('z');
    const localDate = moment.utc(date).local().format(format);
    formattedDate = `${localDate} ${LOCAL_TZ_CODE}`;
  }
  return formattedDate;
};
export const capitalize = (str: string) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '');
